import styled, { css } from "styled-components";
import Select from "../Select/Select";

export const AutocompleteRoot = styled(Select)(
    () => css`
        .DisplayContent {
            width: 100%;
            margin-right: 0;
            max-width: 100%;
        }
    `,
) as typeof Select;
